import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faExternalLinkAlt from '@fortawesome/fontawesome-free-solid/faExternalLinkAlt';
import Loading from '../../../../components/Loading';
import { TableWrapper, TableContainer, Table, StatusContainer } from './styled';
import { getPlanFeesByPartner } from '../../../../../server/scripts/planTiers';
const { getPlanFees } = require('../../../../../server/scripts/utils.js')();

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      loading: false,
    };

    this.downloadTransactions = this.downloadTransactions.bind(this);
  }

  componentDidMount() {
    if (this.props.userInfo.publisher) {
      this.retrieveTransactions(this.props.userInfo.publisher.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.userInfo.publisher &&
      nextProps.userInfo.publisher !== this.props.userInfo.publisher
    ) {
      this.retrieveTransactions(nextProps.userInfo.publisher.id);
    }
  }

  downloadTransactions(e) {
    e.preventDefault();
    const { userInfo } = this.props;
    window.location.href = `/api/transactions/csvexport/${userInfo.publisher.id}`;
  }

  retrieveTransactions(publisherId) {
    this.setState({
      loading: true,
    }, () => {
      Axios.get('/api/transactions', {
        params: {
          filter: {
            where: { publisherId },
          },
        },
      })
        .then(({ data: transactions }) => {
          transactions.sort((a, b) => {
            return moment(b.createdAt).format('X') - moment(a.createdAt).format('X');
          });

          this.setState({
            transactions,
            loading: false,
          });
        })
        .catch(err => {
          console.log('error retrieving transactions: ', err);
          this.setState({ loading: false });
        });
    });
  }

  getListener({ listenerName = '', listenerEmail = '' }) {
    if (isEmpty(listenerName) && isEmpty(listenerEmail)) {
      return '-';
    }

    return `${listenerName} (${listenerEmail})`;
  }

  isCharge(transaction) {
    return transaction.type === 'charge';
  }

  renderBody() {
    const { transactions = [], loading } = this.state;
    const { userInfo = {} } = this.props;

    if (!('publisher' in userInfo) || loading) {
      return (
        <div className="row">
          <div className="col-md-12">
            <StatusContainer>
              <Loading text="Loading transactions" align="center" />
            </StatusContainer>
          </div>
        </div>
      );
    }

    const { plan = '', referredBy = '' } = userInfo.publisher;
    if (isEmpty(transactions)) {
      return (
        <div className="row">
          <div className="col-md-12">
            <StatusContainer className="title-small">
              <span>There are no transactions to show.</span>
            </StatusContainer>
          </div>
        </div>
      );
    }

    return (
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="table-wrapper table-responsive">
            <TransactionsHeader>
              <DownloadTransactions onClick={this.downloadTransactions}>
                <i className="material-icons">
                  cloud_download
                </i>
                <span className="text-medium font-weight-600 hidden-xs">Download Transactions</span>
              </DownloadTransactions>
            </TransactionsHeader>
            <TableContainer>
              <TransactionsTable className="table table-hover">
                <thead>
                  <tr>
                    <th>DATE</th>
                    <th>TYPE</th>
                    <th>DESCRIPTION</th>
                    <th>AMOUNT</th>
                    <th>RECEIPT</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction, i) => {
                    const isTrial = transaction.chargeId === 'trial';
                    const isNotShopify = !(transaction.transactionId || '').includes('shopify_');;
                    const type = this.isCharge(transaction) ? 'Sale' : 'Refund';
                    const price = Number(transaction.amount).toFixed(2);
                    const currency = 'currency' in transaction ? transaction.currency.toUpperCase() : 'USD';
                    const creditCardCharge = -0.01 < price && price < 0.01 ? 0 : (price * 0.029 + 0.3).toFixed(2); // Stripe charge
                    const soundwiseFee = (getPlanFeesByPartner(plan, referredBy, true) * Number(price)).toFixed(2);
                    const amount =
                      this.isCharge(transaction) && isNotShopify
                        ? (price - creditCardCharge - soundwiseFee).toFixed(2)
                        : (+price).toFixed(2);
                    const receiptUrl = transaction.receiptUrl;

                    return (
                      <tr key={i}>
                        <td>
                          {this.isCharge(transaction)
                            ? transaction.date.slice(0, 10)
                            : transaction.refund_date.slice(0, 10)}
                        </td>
                        <td>{type}</td>
                        <td>{transaction.description}</td>
                        <td>
                          <div className="font-weight-600">
                            {`${this.isCharge(transaction) ? '' : '-'} ${currency} ${amount}`}
                          </div>
                          <div className="text-extra-medium text-light-gray2">
                            {!isNotShopify ? `» Shopify` 
                              : isTrial ? `» Trial`
                              : `» Price: ${this.isCharge(transaction) ? '' : '-'} ${currency} ${price}${this.isCharge(transaction) ? '' : ')'}`}
                          </div>
                          {(!isTrial && isNotShopify) && <>
                            <div className="text-extra-medium text-light-gray2">
                            {(this.isCharge(transaction) &&
                              `» Credit card processing fee: ${
                                this.isCharge(transaction) ? '-' : ''
                              } ${currency} ${creditCardCharge}`) ||
                              null}
                          </div>
                          <div className="text-extra-medium text-light-gray2">
                            {(this.isCharge(transaction) &&
                              `» Soundwise fee: ${
                                this.isCharge(transaction) ? '-' : ''
                              } ${currency} ${soundwiseFee}`) ||
                              null}
                          </div>
                          </>}
                        </td>
                        <td>
                          {receiptUrl && (
                            <a href={receiptUrl}
                              target="_blank"
                              title="Open in new tab"
                              className="text-large tz-text">
                              <FontAwesomeIcon icon={faExternalLinkAlt}/>
                            </a>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </TransactionsTable>
            </TableContainer>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <TableWrapper>
        {this.renderBody()}
      </TableWrapper>
    );
  }
}

const TransactionsHeader = styled.div`
  background: #fff;
  padding: 20px 24px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  border-bottom: 1px solid #eee;
  margin-top: 25px;
`;

const DownloadTransactions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  i {
    color: #646464;
    margin-right: 5px;
  }

  &:hover {
    i {
      color: #1f1f1f;
    }
  }
`;

const TransactionsTable = styled(Table)`
  tbody {
    > tr {
      > td {
        .date {
          font-weight: 600;
        }
      }
    }
  }
`;

export default Transactions;
